module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.7073/images/default-avatar.png"